import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';

/**
 * Component to let the user select a boolean value. It is displayed as
 * a checkbox.
 * @remarks If using v-wmodel, always add the modifier .lazy
 */
var CheckboxComponent = /** @class */ (function (_super) {
    __extends(CheckboxComponent, _super);
    function CheckboxComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxComponent.prototype.handleChange = function (event) {
        if (!(event.target instanceof HTMLInputElement)) {
            return;
        }
        var isChecked = event.target.checked;
        if (this.radio && isChecked === false) {
            event.target.checked = true;
            event.preventDefault();
            return;
        }
        this.onChange(isChecked);
    };
    CheckboxComponent.prototype.onChange = function (isChecked) {
        return isChecked;
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CheckboxComponent.prototype, "value", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CheckboxComponent.prototype, "bold", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CheckboxComponent.prototype, "inline", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CheckboxComponent.prototype, "noLabel", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CheckboxComponent.prototype, "noMargin", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CheckboxComponent.prototype, "hasError", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CheckboxComponent.prototype, "radio", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], CheckboxComponent.prototype, "indeterminate", void 0);
    __decorate([
        Emit('change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], CheckboxComponent.prototype, "onChange", null);
    CheckboxComponent = __decorate([
        Component({
            name: 'ui-checkbox',
        })
    ], CheckboxComponent);
    return CheckboxComponent;
}(Mixins(MagicConfigMixin)));

export default CheckboxComponent;
